import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';
import utils from 'utils';
import WINDOW_OBJECT_KEYS from 'constants/windowObjectKeys';

export const deeplinkIntoReservationFlow =
  (params, options = { redirect: true }) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        loadingOverlay: options.loadingOverlay,
        action: actions.request({
          data: {
            params,
            endpoint: {
              version: 3,
            },
          },
          service: services.gma.deeplink,
        }),
        redirect: options.redirect,
        onComplete: (response) => {
          if (response.messages && options.redirect) {
            // redirect to #start page
            window.location.assign(utils.config.getRedirectUrl(WINDOW_OBJECT_KEYS.RESERVATION_INFLOW));
          }
          // calling initVehicleSelectFilters only when reservation object is present, else it throws error is reservation object is not present.
          if (response?.session?.gbo?.reservation && options.initVehicleFilters) {
            dispatch(actions.reservations.initVehicleSelectFilters());
          }

          return response;
        },
      })
    );
